import { Spinner } from 'common'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { processOrganizationTemplateReview } from './api'
import { Button } from 'ui-common'

const TemplateReviewDecision = () => {
	const params = useParams<{ id: string; decision: string }>()
	const { id, decision } = params
	const [errorMessage, setErrorMessage] = useState<string | null>(null)
	const [loading, setLoading] = useState<boolean>(true)

	const handleTemplateDecision = async (templateId: string, decision: 'approve' | 'reject') => {
		const status = decision === 'approve' ? 'approved' : decision === 'reject' ? 'rejected' : null

		if (!status) {
			setErrorMessage('Invalid URL provided.')
			return
		}

		try {
			setLoading(true)
			const success = new URLSearchParams(window.location.search).get('success')
			if (success !== 'true') {
				await processOrganizationTemplateReview(Number(templateId), status)
				window.history.replaceState({}, '', `/templates/${templateId}/${decision}?success=true`)
			}
		} catch (error) {
			console.error('Error updating template status:', error)
			setErrorMessage((error as { errorMessage?: string }).errorMessage || 'Failed to update template status. Please try again.')
			// Handle the error, e.g., show an error message to the user
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (!errorMessage && id && decision) {
			handleTemplateDecision(id, decision as 'approve' | 'reject')
		}
		// handleTemplateDecision is deliberately omitted: it is re-created on every
		// render, so listing it would re-trigger this run-once effect in a loop.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [decision, id, errorMessage])

	if (errorMessage) {
		return (
			<div className='w-full flex items-center justify-center h-full flex-col gap-4'>
				<div className='text-red-500'>Failed to update template. {errorMessage}</div>
				<Button outline onClick={() => setErrorMessage(null)}>
					Retry
				</Button>
			</div>
		)
	}

	if (loading) {
		// Show a loading spinner while the request is being processed
		return (
			<div className='w-full flex items-center justify-center h-full'>
				<Spinner text='Processing your request...' />
			</div>
		)
	}

	return (
		<div className='w-full flex items-center justify-center h-full flex-col gap-4'>
			<div className='text-green-500'>
				{decision === 'approve' ? 'Template approved successfully!' : 'Template rejected and deleted successfully !'}
			</div>
			<Button outline onClick={() => (window.location.href = '/whatsapp')}>
				Go to WhatsApp
			</Button>
		</div>
	)
}

export default TemplateReviewDecision
